export const INVOICE_DOWNLOAD_IDENTIFIER = {
  label: 'DocumentNumber',
  value: 'documentNumber',
} as const;

export const flagInvoiceIdentifierField = 'documentNumber';

export const INVOICE_RECONCILIATION_FIELDS = [
  'VendorCode',
  'Year',
  'Month',
  'AmountIncludeVat',
  'Currency',
  'TaxAmountInCountryCurrency',
  'TaxCountryCurrencyKey',
  'Count',
] as const;

export const DEFAULT_INVOICE_SORTING_FOR_DOWNLOAD = [
  { Direction: 'ascending', Field: 'IssueDate' },
];

export const INVOICE_STATUS_LIST = [
  'Open(booked)',
  'Cleared',
  'Cleared - paid',
  'Parked',
  'Deleted',
] as const;

export const INVOICE_FLAGS_LIST = [
  { id: '', name: 'All' },
  { id: 'reviewed', name: 'Reviewed' },
  { id: '!reviewed', name: 'Not Reviewed' },
] as const;

export const PURCHASING_ORGANISATIONS_LIST = [
  'CZFC',
  'CZFN',
  'CZGL',
  'CZGS',
  'CZLC',
  'CZLS',
  'HKFT',
  'HUPC',
  'RUFN',
  'TRFN',
] as const;
